import Typography from "@mui/material/Typography";
import TextFieldStyled from "@/components/TextFieldStyled";

const NetworkLocationFormContact = ({onChange}) => {

    const handleInputChanged = (event, value) => {
        if (onChange && typeof onChange === "function") {
            onChange(event, value);
        }
    }

    return (
        <>
            <Typography variant="h4" component="p" color="common.black" sx={{ mt: 4,}}>
                Deine Kontaktdaten
            </Typography>
            <TextFieldStyled
                required={true}
                type="text"
                name="creator_name"
                label="Dein Vor- und Nachname"
                placeholder="Kim Mustername"
                onChange={handleInputChanged}
            />
            <TextFieldStyled
                required={true}
                type="email"
                name="creator_email"
                label="Deine E-Mail Adresse"
                placeholder="mail@example.com"
                onChange={handleInputChanged}
            />
        </>
    )
}

export default NetworkLocationFormContact;
